export default __webpack_public_path__ + "static/media/To_Do_List_React.b9225dbf.PNG";